/* src/app/pages/project/map/repository/import-wizard/import-wizard.component.scss */
.import-wizard-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 1200px;
  height: 90vh;
  background: var(--color-bg);
  color: var(--color-text);
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  border: none;
  outline: none;
  overflow: hidden;
}
.close-button {
  position: absolute;
  top: 12px;
  right: 20px;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  color: var(--color-primary);
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s ease;
}
.close-button:hover {
  color: var(--color-text);
}
.close-button svg {
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=import-wizard.component-RAPOI6ZA.css.map */
